import { createFileRoute } from "@tanstack/react-router";
import { useEffect, type FC } from "react";

const GOOGLE_PHOTOS_URL = "https://photos.app.goo.gl/hf3mLUyhHg3CHKnz9";

const RouteComponent: FC = () => {
	// Automatické přesměrování na Google Fotky po načtení stránky
	useEffect(() => {
		// Malé zpoždění pro lepší UX - uživatel uvidí krátce stránku před přesměrováním
		const timer = setTimeout(() => {
			window.location.href = GOOGLE_PHOTOS_URL;
		}, 2000);

		return () => clearTimeout(timer);
	}, []);

	const handleManualRedirect = () => {
		window.location.href = GOOGLE_PHOTOS_URL;
	};

	return (
		<div className="container mx-auto px-4 py-8 md:py-16">
			<div className="max-w-4xl mx-auto text-center">
				<h2 className="text-4xl md:text-5xl font-serif text-[#7D9F7D] mb-12 md:mb-16">
					Galerie
				</h2>

				<div className="bg-white rounded-lg shadow-lg p-8 mb-8">
					<div className="mb-6">
						<div className="inline-block animate-spin rounded-full h-8 w-8 border-4 border-rose-500 border-t-transparent mb-4" />
						<p className="text-lg text-gray-700 mb-4">
							Přesměrováváme vás na naši svatební galerii...
						</p>
					</div>

					<p className="text-gray-600 mb-6">
						Naše svatební fotografie najdete v Google Fotkách, kde si je můžete prohlédnout
						a také přidat své vlastní snímky ze svatebního dne.
					</p>

					<button
						onClick={handleManualRedirect}
						className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-[#7D9F7D] hover:bg-[#6B8B6B] transition-colors duration-200"
					>
						<svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
						</svg>
						Otevřít galerii nyní
					</button>

					<p className="text-sm text-gray-500 mt-4">
						Pokud se nepřesměrujete automaticky, klikněte na tlačítko výše.
					</p>
				</div>

				<div className="bg-green-50 border border-green-200 rounded-lg p-6">
					<h3 className="text-lg font-semibold text-green-800 mb-2">
						📸 Jak přidat své fotky
					</h3>
					<p className="text-green-700">
						V Google Fotkách můžete přidat své vlastní fotografie ze svatby.
						Stačí kliknout na tlačítko "Přidat fotky" a vybrat snímky ze svého zařízení.
					</p>
				</div>
			</div>
		</div>
	);
};

export const Route = createFileRoute("/gallery")({
	component: RouteComponent,
});
